import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './APIFrame.css';
var APIFrame = function APIFrame(props) {
  var children = props.children,
    customClass = props.customClass,
    id = props.id,
    src = props.src,
    title = props.title,
    onLoad = props.onLoad;
  var bemClasses = getBEMClasses('kyc-iframe');
  return React.createElement('iframe', {
    allow: 'camera',
    title: title,
    className: bemClasses(customClass),
    id: id,
    src: src,
    onLoad: onLoad
  }, children);
};
APIFrame.defaultProps = {
  id: '',
  src: '',
  onLoad: function onLoad() {},
  title: 'kyc-iframe',
  customClass: ''
};
APIFrame.propTypes = {
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  title: PropTypes.string,
  customClass: PropTypes.string
};
export default APIFrame;